import React from "react";
import { useSelector } from 'react-redux';
import { IKIOSKModel, IkioskMenuIds } from "../../../../models/kioskModel2";
import Emiratesidverified from "../../../kiosk/theme1/components/emiratesidverified";
import MobilenumberVarification from "../../../kiosk/theme1/components/mobilenumberVarification";
import LoginMenus from "../../../kiosk/theme1/components/loginMenus";
import Appoinements from "../../../kiosk/theme1/components/appoinements";
import OtherServicesMenu from "../../../kiosk/theme1/components/otherServicesMenu";
import AuthSuccesMenus from "../../../kiosk/theme1/components/authSuccesMenus";
import TokensView from "../../../kiosk/theme1/components/tokensView";
import LanguageSelection from "../../../kiosk/theme1/components/languageSelection";
import ThankYouPage from "../../../kiosk/theme1/components/thankYouPage";
import PromotinalSlides from "../../../kiosk/theme1/components/promotinalSlides";
import QRScannerLogin from "../../../kiosk/theme1/components/qrScannerLogin";
import DobPage from "../../../kiosk/theme1/components/dobPage";
import ErrorMessageModel from "../../../kiosk/theme1/components/errorMessageModel";
import PageLoading from '../components/pageLoading';


const ThemeOneKioskManager: React.FC = () => {
    const selectedPage: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.selectedPage || IkioskMenuIds.LOGINPAGE);
    console.log("selectedPage==>>", selectedPage);
    const getSelectedAreaComponent = (value) => {
        switch (value) {
            case IkioskMenuIds.INSERTEMIRATESID:
                return <Emiratesidverified />;
            case IkioskMenuIds.SCANQR:
                return <QRScannerLogin />;
            case IkioskMenuIds.INPUTMOBILE:
                return <MobilenumberVarification />;
            case IkioskMenuIds.NEWPATIENT:
                return <MobilenumberVarification />;
            case IkioskMenuIds.WELCOMEPAGE:
                return <AuthSuccesMenus />;
            case IkioskMenuIds.APPOINMENTS:
                return <Appoinements />;
            case IkioskMenuIds.OTHERSERVICES:
                return <OtherServicesMenu />;
            case IkioskMenuIds.TOKEN:
                return <TokensView />;
            case IkioskMenuIds.ERRORPAGE:
                return <ErrorMessageModel />;
            case IkioskMenuIds.LANGUAGE:
            case IkioskMenuIds.NEWPATIENTLANGUAGE:
                return <LanguageSelection />;
            case IkioskMenuIds.AUTHFAILED:
                return <ThankYouPage />
            case IkioskMenuIds.PROMOTIONALSLIDE:
                return <PromotinalSlides />
            case IkioskMenuIds.DOBPAGE:
                return <DobPage />
            // case IkioskMenuIds.PAGELOADING:
            //     return <PageLoading />
            default:
                return <LoginMenus />
        }
    };
    return (
        <>
            {getSelectedAreaComponent(selectedPage)}
        </>
    )
}
export default React.memo(ThemeOneKioskManager);